import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { StatusBar, Style } from '@capacitor/status-bar'
import { SecureStorage } from '@aparajita/capacitor-secure-storage'
import { focusManager } from '@tanstack/react-query'
import { setTokenStore, type TokenStore } from '@/lib/authStorage'

/**
 * Native-only wiring for the iOS app. Everything here is a no-op on the web, so the
 * rest of the app can call these unconditionally.
 */

export const isNative = Capacitor.isNativePlatform()

const TOKEN_KEY = 'plumb.session'

const keychainTokenStore: TokenStore = {
  get: () => SecureStorage.getItem(TOKEN_KEY),
  set: (token) => SecureStorage.setItem(TOKEN_KEY, token),
  clear: () => SecureStorage.removeItem(TOKEN_KEY),
}

/** Call once before the first render. */
export function initNative(): void {
  if (!isNative) return

  // The session token lives in the iOS Keychain and is sent as a Bearer header.
  setTokenStore(keychainTokenStore)

  // Refetch stale queries when the app returns to the foreground, like a browser tab
  // regaining focus.
  void App.addListener('appStateChange', ({ isActive }) => focusManager.setFocused(isActive))
}

/** Keep the status bar text readable over the app's own light/dark theme. */
export function syncStatusBar(theme: 'light' | 'dark'): void {
  if (!isNative) return
  void StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light })
}
